import { APIMethod, fetchData } from "@client";

export async function removeProjectContractorQuery(uuid, email) {
  const data = { uuid, email };
  return await fetchData("/project/contractor", APIMethod.DELETE, { data });
}

